exports.show = function() {
    document.getElementById('spinner').style.display = 'block';
};

exports.hide = function() {
    document.getElementById('spinner').style.display = 'none';
};
